// extracted by mini-css-extract-plugin
module.exports = {"container":"Featured__container--22jaG","image":"Featured__image--373lN","text":"Featured__text--27wLl","title":"Featured__title--2MooR","subtitle":"Featured__subtitle--3-DML"};
    if(module.hot) {
      // 1617221670855
      var cssReload = require("!../../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  